import { render, staticRenderFns } from "./SKLFamily.vue?vue&type=template&id=749a062a"
import script from "./SKLFamily.vue?vue&type=script&lang=js"
export * from "./SKLFamily.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports